import {
  ACTION_EDIT_EXPENSE,
  ACTION_EDIT_EXPENSE_SUCCESS,
  ACTION_EDIT_EXPENSE_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

interface EditExpenseParams {
  expenseIds: string[];
  syncToGlStatus: string;
}

export function editExpense(params: EditExpenseParams) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: 'expenses',
        method: 'put',
        data: JSON.stringify({
          expenseIds: params.expenseIds,
          syncToGlStatus: params.syncToGlStatus,
        }),
        success: (response: any) => {
          enqueueSnackbarHandler(
            dispatch,
            { editExpenseSuccess: true },
            'success',
          );
          dispatch(requestSuccess(response));
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

function requestStarted() {
  return {
    type: ACTION_EDIT_EXPENSE,
    payload: null,
  };
}

function requestSuccess(response: any) {
  return {
    type: ACTION_EDIT_EXPENSE_SUCCESS,
    payload: response,
  };
}

function requestFailed(error: any) {
  return {
    type: ACTION_EDIT_EXPENSE_FAILURE,
    payload: error,
  };
}
